import { h } from 'preact';
import {
  FORWARD_SHORTCUT,
  MUTE_SHORTCUT,
  PLAY_PAUSE_CLICK_SHORTCUT,
  PLAY_PAUSE_SHORTCUT,
  REWIND_SHORTCUT,
  SHORTCUT_MAP,
  SPEED_SHORTCUT,
  VOLUME_DOWN_SHORTCUT,
  VOLUME_UP_SHORTCUT
} from '../../../../core/shortcut/types';
import { isShortcutNotAllowed } from '../../../../utils';
import { getSpeedObjectByRate } from '../../../../utils/tracks';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import '../../../common/theme/styles/feedback.css';
import {
  BACKWARD_BUTTON_FILL_PATH,
  FORWARD_BUTTON_FILL_PATH,
  PAUSE_BUTTON_PATH,
  PLAY_BUTTON_PATH,
  VOLUME_FILL_MODERATE,
  VOLUME_FILL_MUTE
} from '../../../common/theme/svg';
import { getScale, getVolumeIcon } from '../../../common/utils/tools';
import { withBreakPoints } from '../../hoc';
import { SVGCreator } from '../common';
import { DEFAULT_ICON, DEFAULT_STYLE } from './styles';

const KEYCODE_MAP = {
  [PLAY_PAUSE_SHORTCUT]: ({ isPlaying }) => (isPlaying ? PLAY_BUTTON_PATH : PAUSE_BUTTON_PATH),
  [PLAY_PAUSE_CLICK_SHORTCUT]: ({ isPlaying }) => (isPlaying ? PLAY_BUTTON_PATH : PAUSE_BUTTON_PATH),
  [MUTE_SHORTCUT]: ({ muted }) => (muted ? VOLUME_FILL_MUTE : VOLUME_FILL_MODERATE),
  [FORWARD_SHORTCUT]: () => FORWARD_BUTTON_FILL_PATH,
  [REWIND_SHORTCUT]: () => BACKWARD_BUTTON_FILL_PATH,
  [VOLUME_UP_SHORTCUT]: (props) => (getVolumeIcon({ ...props }, { fill: true })),
  [VOLUME_DOWN_SHORTCUT]: (props) => (getVolumeIcon({ ...props }, { fill: true })),
  [SPEED_SHORTCUT]: ({ rate }) => (getSpeedObjectByRate(rate)?.svgData || [])
};

const matchSvgByKeyCode = ({ keyCode, hasDialogOpened, pauseRollIsDisplayable, volumeSliderVisible, displayType }) => {
  if (isShortcutNotAllowed({ keyCode, hasDialogOpened, pauseRollIsDisplayable, volumeSliderVisible, displayType })) return null;
  return (KEYCODE_MAP[SHORTCUT_MAP[keyCode]] ? KEYCODE_MAP[SHORTCUT_MAP[keyCode]] : null);
};

const resolveStyle = (keycode) => {
  if (keycode === FORWARD_BUTTON_FILL_PATH) {
    return DEFAULT_STYLE.iconRight;
  } if (keycode === BACKWARD_BUTTON_FILL_PATH) {
    return DEFAULT_STYLE.iconLeft;
  }
  return DEFAULT_STYLE.iconCenter;
};

function FeedbackOverlays(oldProps) {
  const player = usePlayerContext();
  const { feedback, keyCode, hasDialogOpened, volumeSliderVisible, displayType } = useNewStore('ui', player);
  const { isPlaying, rate } = useNewStore('playback', player);
  const volumeState = useNewStore('volume', player);
  const { pauseRollIsDisplayable } = useNewStore('ad', player);
  const props = {
    ...oldProps,
    isPlaying,
    rate,
    keyCode,
    volume: volumeState.level,
    muted: volumeState.muted
  };
  const resolveSVG = matchSvgByKeyCode({ keyCode, rate, hasDialogOpened, pauseRollIsDisplayable, volumeSliderVisible, displayType });
  return (
    resolveSVG ? (
      <div style={DEFAULT_STYLE.container}>
        {feedback && (
          <SVGCreator
            paths={resolveSVG(props)}
            width={DEFAULT_ICON.width * getScale(props)}
            height={DEFAULT_ICON.height * getScale(props)}
            style={resolveStyle(resolveSVG(props))}
          />
        )}
      </div>
    ) : null
  );
}

export default withBreakPoints(FeedbackOverlays);
